module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo5.png"),
      "alt": "logo"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("产品展示")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "underline",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/news"
    },
    on: {
      "click": function($event) {
        return _vm.route()
      }
    }
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/joinus"
    }
  }, [_vm._v("加入我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-btn d-inline-flex"
  }, [_c('div', {
    staticClass: "input-group flex-nowrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": "查询产品",
      "aria-label": "搜索"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-search",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  })])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "qqkefu"
  }, [_c('ul', [_c('li', {
    staticClass: "top anchor",
    on: {
      "click": function($event) {
        return _vm.returntop()
      }
    }
  }, [_vm._v("TOP"), _c('span')]), _vm._v(" "), _c('li', {
    staticClass: "qq_cza",
    on: {
      "click": function($event) {
        return _vm.toQQ()
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area section-padding4 section-padding5"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-2 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("产品导航")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("西安天隆")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海智城")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海屹谱")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("北京中仪宇盛")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('ul', {
    staticStyle: {
      "padding-top": "55px"
    }
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海仪硕")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海美瑞克")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("宁波新芝")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("北京大龙")])])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("Copyright © 北京泽浩天科技发展有限公司　备案号：京ICP备2025103103号-1")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "a"
  }), _vm._v("咨询")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qq_cza",
    attrs: {
      "id": "zx"
    }
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "b"
  }), _vm._v("在线咨询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qq_czb"
  }, [_c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "static/assets/images/qrcode.png"
    }
  }), _vm._v("二维码")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("电话：010-67047381，010-61807868")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("电子邮箱：zehaotian@139.com")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("公司地址：北京市门头沟区熙旺中心A座1026")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "100px"
    },
    attrs: {
      "src": "/static/assets/images/qrcode.png",
      "alt": "feed"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa4fa8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 303
// module chunks = 2